import React from "react";
import { Container, Grid, useMediaQuery } from "@material-ui/core";
import {
  SimpleLoading,
  PromotionalFooterPure,
  DialogSystemGLPure,
  TitleTemplatePure,
  CardTemplatePure,
} from "../../pures";
import "./signature-request-module.css";

const SignatureRequestModuleView = (props) => {
  // Container custom styles

  const longmatches = useMediaQuery("(max-width:1200px)");

  const globalContainerStyles = {
    display: "inline-block",
    justifyContent: "flex-start",
    maxWidth: "100%",
    backgroundColor: "white",
    width: "100%",
    // paddingTop: "20px",
  };
  if (longmatches) {
    globalContainerStyles.marginRight = 0;
  }
  const containerTableAndHeadersStyles = {
    marginTop: "20px",
    maxWidth: "100%",
    justifyContent: "start",
  };

  return (
    <div className="standard-wrapper">
      {props.loading ? (
        <SimpleLoading />
      ) : (
        <Container spacing={4} lg={12} md={12} style={globalContainerStyles}>
          <Grid item xs={12} lg={12} md={12} sm={12} es={12}>
            <TitleTemplatePure title={props.title} />
          </Grid>
          <Grid container xs={12} lg={12} md={12} sm={12} es={12} className='signatureRequestModule-content'>
            <Grid item xs={6} lg={12} md={12} sm={12} es={12} className='container-cards-signatureRequestModule'>
              {props.userProfiles.map((item, index) =>
                <Grid className='card-signatureRequestModule'>
                  <CardTemplatePure
                    {...item}
                    key={index}
                  />
                </Grid>
              )}
            </Grid>
            {/* Componet pure "Promotional footer" */}
            <Grid
              item
              xs={12}
              lg={12}
              md={12}
              sm={12}
              style={containerTableAndHeadersStyles}
            >
              <PromotionalFooterPure />
            </Grid>
          </Grid>

          {/* Alerts of Notification Completed and Loadign */}
          <DialogSystemGLPure
            {...props}
            toggleLoadingRequesting={props.toggleLoadingRequesting}
            toggleCompletedRequesting={props.toggleCompletedRequesting}
            toggleErrorRequesting={props.toggleErrorRequesting}
          />
        </Container>
      )}
    </div>
  );
};

export { SignatureRequestModuleView as default };
